module.exports = __webpack_public_path__ + "static/img/cont51 (3).e818e01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont51 (3).jpg
// module id = pc70
// module chunks = 0